import logoIA from '@assets/Logo-IA.png'
import close from '@assets/nuevos-iconos/x.png'
import { fetchIA } from '@proxies/iaProxy'
import * as Form from '@radix-ui/react-form'
import * as Select from '@radix-ui/react-select'
import { useAppStore } from '@store'
import React, { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export function IAForm() {
  const { state } = useLocation()
  const prefs = useAppStore.use.prefs()
  const t = useAppStore.use.t()
  const navigate = useNavigate()

  const respuestas = [
    'Moderno',
    'Minimalista',
    'Contemporaneo',
    'Escandinavo',
    'Zen',
    'Tropical',
    'Bohemio',
    'Futurista',
    'Industrial',
    'Artdeco',
    'Rustico',
    'Vintage',
    'Clasico',
  ]

  const SelectItem = React.forwardRef<HTMLDivElement>(function ItemSelect(
    { children, ...props },
    forwardedRef,
  ) {
    return (
      <Select.Item
        {...props}
        ref={forwardedRef}
      >
        <Select.ItemText>{children}</Select.ItemText>
      </Select.Item>
    )
  })

  useEffect(() => {
    if (!document.body) {
      return
    }
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        navigate('/ia')
      }
    }
    document.body.addEventListener('keydown', handleKey)
    return () => {
      document.body.removeEventListener('keydown', handleKey)
    }
  })

  const formfield = 'mt-1.5 ml-24 flex flex-col items-start text-C/ColorF06 '

  const tipoBg = {
    dormitorio: prefs.PREDEF_IA_01_IMAGE_2,
    'sala de estar': prefs.PREDEF_IA_02_IMAGE_2,
    'habitacion juvenil': prefs.PREDEF_IA_03_IMAGE_2,
    baño: prefs.PREDEF_IA_04_IMAGE_2,
    comedor: prefs.PREDEF_IA_05_IMAGE_2,
    cocina: prefs.PREDEF_IA_06_IMAGE_2,
  }

  const handleClick = async (type, answer) => {
    navigate('spinner', { state: answer })
    const url = await fetchIA(type, answer)
    setTimeout(() => {
      navigate('imgIAGen', { state: url.images })
    }, 2000)
  }

  return (
    <div className=' h-screen w-screen bg-black'>
      <Outlet />
      <div className=' absolute right-24 top-5 z-10 mr-2 cursor-pointer'>
        <img
          onClick={() => {
            navigate('/ia')
          }}
          role='button'
          src={close}
          className='cursor-pointer'
        />
      </div>
      <img
        className=' absolute left-0 top-0 h-screen w-screen'
        src={tipoBg[state]}
      />

      <Form.Root className=' absolute left-0 top-0 h-screen w-[48rem]'>
        <div className='my-2 flex h-[66px] w-screen items-center justify-between'>
          <img
            className='ml-16 h-12 '
            src={logoIA}
          />
          <p className='ml-[4rem] text-center text-[28px] font-semibold text-C/ColorF11'>
            {'Inspira tus proyectos con IA'}
          </p>
          <div className='w-96'></div>
        </div>
        <p className='-ml-3 -mt-2 mb-4 w-screen pl-1.5 text-center text-xl text-C/ColorF06'>
          {'Interpretaremos tus necesidades y gustos a partir de las siguientes preguntas'}
        </p>
        <Form.Field
          name='lang'
          className={formfield}
        >
          <Form.Label className='mr-4 text-lg text-C/ColorF06'>{'Selecciona tu estilo'}</Form.Label>
          <Form.Control asChild>
            <Select.Root onValueChange={(e) => handleClick(state, e)}>
              <Select.Trigger className=' mt-2 w-[19.4rem] border border-solid border-C/ColorF06 bg-black text-base font-semibold text-white '>
                <Select.Value
                  className='pb-3'
                  placeholder={respuestas[0]}
                ></Select.Value>
              </Select.Trigger>
              <Select.Portal>
                <Select.Content position='popper'>
                  <Select.Viewport className=' mt-0.5'>
                    <Select.Group className=' h-min w-[19.4rem] cursor-pointer select-none rounded-lg border border-solid border-C/ColorF06 bg-black p-[5px] text-center text-C/ColorF06 '>
                      {respuestas &&
                        respuestas.map((rsp) => {
                          return (
                            <SelectItem
                              key={`${rsp}+`}
                              className={rsp}
                              value={rsp}
                            >
                              {rsp}
                            </SelectItem>
                          )
                        })}
                    </Select.Group>
                  </Select.Viewport>
                </Select.Content>
              </Select.Portal>
            </Select.Root>
          </Form.Control>
        </Form.Field>
      </Form.Root>
    </div>
  )
}
